<script>
import BasePage from './BasePage'
// import { timeMethod } from '@/assets/utils/util.js';
export default {
  name: 'BaseTable',
  extends: BasePage,
  data () {
    return {
      props: {
        multiple: false,
        label: 'name',
        value: 'id',
        children: 'subList',
        checkStrictly: true,
        emitPath: false
      },
      // 是否展示
      visible: {
        // 添加/修改数据窗口
        operaTable: false
      },
      rowIndex: '',
      // 是否正在执行
      isWorking: {
        // 添加/修改中
        operaTable: false,
        // 搜索中
        loading: false,
        // 删除中
        delete: false,
        // 排序中
        sort: false
      },
      dateOptions: {
        disabledDate (time) {
          return time.getTime() >= Date.now();
        }
      }, // 搜索时间的初始化条件
      // 表格数据
      tableData: {
        // 已选中的数据
        selectedRows: [],
        // 当前页数据
        list: [],
        // 分页
        pagination: {
          pageIndex: 1,
          pageSize: 20,
          total: 0
        }
      }
    }
  },
  methods: {
    // 搜索
    search (obj = {}) {
      this.handlePageChange(1, obj)
    },
    /**
     * 开始时间选中的回调
     * @function dateChange
     * @param  {String} val 时间文本
     */
    // 每页显示数量变更处理
    handleSizeChange (val) {
      this.tableData.pagination.pageSize = val
      this.search({ msg: true })
    },
    // 行选中处理
    handleSelectionChange (selectedRows) {
      this.tableData.selectedRows = selectedRows
    },
    // 为行对象(row)设置index属性
    tableRowClassName ({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // 设置行对象(row)的样式(style)
    selectedstyle ({ row, rowIndex }) {
      if (this.rowIndex === rowIndex) {
        return {
          'background-color': 'oldlace'
        };
      }
    },
    // 关闭新增/修改窗口
    close () {
      this.visible.operaTable = false
    },
    checkData (check = { time: true }) {
      // 校验时间
      if (check.time) {
        if (!this.searchForm.begin || !this.searchForm.end) {
          return {
            error: '请选择时间!'
          }
        }
        if (new Date(this.searchForm.begin) > new Date(this.searchForm.end)) {
          return {
            error: '请选择正确的时间范围!'
          }
        }
      }
      return {}
    },
    // 设置缓存的搜索信息
    initSearchForm () {
      let search = JSON.parse(sessionStorage.getItem(this.pageInfo.search))
      // 当用户搜索过，且用户的实名认证状态和信息不改变的情况下
      if (search) {
        for (let key in this.searchForm) {
          if (search[key] || search[key] === 0) this.searchForm[key] = search[key]
        }
        this.tableData.pagination.pageIndex = search.pageIndex
        if (search.pageSize) this.tableData.pagination.pageSize = search.pageSize
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseTable.vue